import React, { ComponentProps } from 'react';
import { asWidgetProps } from 'Src/types/widget-helpers';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { useAppContext } from 'Context/ReactAppContext';
import { t } from 'Src/i18n';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
type Props = {
  loyaltyPoints: number | null;
  dataTestId?: string;
};
export const GreatMembersLoyaltyPoints = ({
  loyaltyPoints,
  dataTestId = 'greatMembersLoyaltyPoints',
}: Props) => {
  const appContext = useAppContext();
  const isActive = isFeatureFlipped(appContext)('booking.displayGreatMembers');
  if (!isActive || !loyaltyPoints) {
    return null;
  }
  return (
    <div
      className="flex w-full flex-col rounded-12 bg-pearl p-20 md:flex-row md:p-30"
      data-testid={dataTestId}
    >
      <div className="order-3 md:order-3 flex w-full flex-1 justify-center p-4 md:w-auto md:flex-none">
        <Icon
          {...asWidgetProps<ComponentProps<typeof Icon>>({
            name: ICONS.CLUBMED_GREAT_MEMBER_NEW,
            height: '6.25rem',
            width: '6.25rem',
            isNotMonoChrome: true,
          })}
        />
      </div>

      <div className="order-2 flex flex-1 flex-col items-center justify-center p-4 md:order-1 md:flex-2 md:items-baseline md:self-start md:px-30">
        <span className="text-14 font-bold text-black md:text-16">
          {t('booking.priceDetails.greatMembers.title')}
        </span>
        <div className="flex flex-col justify-center p-10">
          <ul className="list-none">
            <li className="list-disc">
              <span className="text-14 text-black md:text-16">
                {t('booking.priceDetails.greatMembers.label1')}
              </span>
            </li>
            <li className="list-disc">
              <span className="text-14 text-black md:text-16">
                {t('booking.priceDetails.greatMembers.label2')}
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="order-1 w-fit justify-center self-center p-4 md:order-2 md:self-start md:py-0">
        <div className="flex w-fit rounded-pill bg-ultramarine px-10">
          <span className="p-5 text-14 font-bold text-white md:text-16">
            {`${t('booking.priceDetails.greatMembers.loyaltyPoints', {
              points: loyaltyPoints,
            })}`}
          </span>
        </div>
      </div>
    </div>
  );
};
